import React from "react";
export const FlowIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.122 8.2357L16.6664 5.7846L14.122 3.3335" fill="currentColor" />
    <path
      d="M14.122 8.2357L16.6664 5.7846L14.122 3.3335"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33334 14.2169H3.94445C5.54667 14.2169 7.33666 12.7291 8.23554 10.8502C8.50665 10.278 11.3055 5.78467 14.2577 5.78467H15.9022M14.1222 11.7646L16.6666 14.2157L14.1222 16.6668"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33334 5.7832H3.94445C5.54667 5.7832 7.33666 7.27097 8.23554 9.14985C8.50665 9.72207 11.3055 14.2154 14.2577 14.2154H15.9022"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
